export default __webpack_public_path__ + "images/ZA.dc6bb18.png";